<template>
  <div>
    <el-dialog title="单据审核" :visible.sync="dialogFormVisible">
      <div class="mch-name">
        {{
          offlinesheet_info.mch_name
            ? "对方店铺" +
              offlinesheet_info.supcust_no +
              "：" +
              offlinesheet_info.mch_name
            : "供应商名称未获取到，可能未绑定线下供应商"
        }}
      </div>
      <el-form
        style="margin-bottom:15px;"
        :rules="rules"
        ref="supNoRef"
        :model="offlinesheet_info"
        label-position="left"
        label-width="200px"
      >
        <el-form-item prop="sup_no" label="线下供应商号">
          <!-- TODO: -->
          <wty-select
            id="1"
            :width="300"
            :size="'mini'"
            :who="'sup'"
            ref="sellerwtySelectRef"
            @getReturn="wtySelectGetReturn"
          ></wty-select>
          
        </el-form-item>
      </el-form>

      <el-form label-position="left" label-width="200px">
        <el-form-item v-if="sheetwho == 'insheet'" label="将新品导入后台">
          <el-radio :disabled="ginfodisab" v-model="radio1" label="1"
            >否</el-radio
          >
          <el-radio :disabled="ginfodisab" v-model="radio1" label="2"
            >将新品导入后台</el-radio
          >
        </el-form-item>
        <el-form-item v-if="sheetwho == 'insheet'" label="修改商品信息">
          <el-radio v-model="radio5" label="1">否</el-radio>
          <el-radio v-model="radio5" label="2">本地商品信息修改</el-radio>
        </el-form-item>
        <!-- <el-form-item v-if="radio1 == '2'" label="线下类别编号">
          <wty-select
            id="1"
            :size="'mini'"
            :width="300"
            who="offlineclass"
            @getReturn="getReturn"
          ></wty-select>
          <div style="color:#409EFF;">无法识别的类别将由此类别代替</div>
        </el-form-item> -->
        <el-form-item
          v-if="radio1 == '2' && sheetwho == 'insheet'"
          label="将进价覆盖本地进价"
        >
          <el-radio v-model="radio2" label="1">否</el-radio>
          <el-radio v-model="radio2" label="2">将进价覆盖后台进价</el-radio>
        </el-form-item>
        <el-form-item
          v-if="radio1 == '2' && sheetwho == 'insheet'"
          label="将售价覆盖本地售价"
        >
          <el-radio v-model="radio3" label="1">否</el-radio>
          <el-radio v-model="radio3" label="2">将售价覆盖后台售价</el-radio>
        </el-form-item>
        <el-form-item
          :label="
            sheetwho == 'insheet' ? '将入库单导入后台' : '将出库单导入后台'
          "
        >
          <el-radio v-model="radio4" label="1">否</el-radio>
          <el-radio v-model="radio4" label="2"
            >{{ sheetwho == "insheet" ? "生成入库单" : "生成出库单" }}
          </el-radio>
        </el-form-item>

        <!-- <el-form-item label="活动区域" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="approve">审核</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { basegoodsBatchquery, sheetApprove } from "@/api/goodsinfo.js";
import wtySelect from "@/components/wty-select.vue";
// import wtySelect from "@/components/wty-select.vue";
import {
  offlineInsertGoods,
  offlinecreateSheet,
  classifySmartDiscern,
  classifyListbindingclassify,
  supplierlistbindingsupplier,
  offlineSearchGoodsInfo,
  offlineGoodsBatchQuery,
  modifyGoods
} from "@/api/offlinestores.js";

import { testR } from "@/api/common";

// import {classifyListbindingclassify} from "@/api/offlinestores.js";
export default {
  name: "dyhAuditsheet",
  data() {
    return {
      ginfodisab: false, //是否导入商品
      dialogFormVisible: false,
      radio1: "1",
      radio2: "1",
      radio3: "1",
      radio4: "1",
      radio5: "1",
      list: [], //传过来的所有商品
      goodslist: [], //需要搜索的所有商品
      modifylist: [], //需要修改的商品
      classlist: [],
      suplist: [],
      sheetwho: "",
      offlinesheet_info: {
        mch_name: "",
        supcust_no: "",
        sheet_no: "",
        branch_no: "",
        detail: [],
        sup_no: ""
      },
      rules: {
        sup_no: [
          { required: true, message: "请选择线下供应商编号", trigger: "change" }
        ]
      }
    };
  },
  components: { wtySelect },
  mounted() {},
  // components: { wtySelect },
  watch: {
    radio4(nradio4, oradio4) {
      if (this.radio4 == "2" && this.sheetwho == "insheet") {
        this.radio1 = "2";
        this.ginfodisab = true;
      } else {
        this.ginfodisab = false;
      }
    }
  },
  methods: {
    showDyhDialog() {
      this.$refs.dyhdialog.showDailog();
    },
    setRadio() {
      const lists = localStorage.getItem("radiochecked");
      if (lists && JSON.parse(lists)) {
        const list = JSON.parse(lists);
        for (let i = 0; i < list.length; i++) {
          this[`radio${i + 1}`] = list[i] ? list[i] : "1";
        }
      }
    },
    wtySelectGetReturn(res) {
      this.offlinesheet_info.sup_no = res.value;
    },
    showDialog(list, mch_no, sheetwho, branch_no, sheet_no) {
      this.dialogFormVisible = true;
      this.list = list;
      this.getclassSup(mch_no);
      this.sheetwho = sheetwho;
      this.offlinesheet_info.branch_no = branch_no;
      this.offlinesheet_info.sheet_no = sheet_no;

      this.setRadio();
    },
    async getclassSup(mch_no) {
      this.suplist = await supplierlistbindingsupplier();
      this.classlist = await classifyListbindingclassify();
      for (let i = 0; i < this.suplist.length; i++) {
        if (this.suplist[i].supplier_no == mch_no) {
          this.offlinesheet_info.mch_name = this.suplist[i].sup_name;
          this.offlinesheet_info.supcust_no = this.suplist[
            i
          ].offline_supplier_no;
          this.offlinesheet_info.sup_no = this.offlinesheet_info.supcust_no;
          this.$refs.sellerwtySelectRef.setSelect(
            this.offlinesheet_info.sup_no
          );
        }
      }
    },
    getGoodsList() {
      this.goodslist = [];
      this.offlinesheet_info.detail = [];
      this.modifylist = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].barcode) {
          if (!this.list[i].item_no) {
            this.goodslist.push(this.list[i].barcode.trim());
          } else if (this.list[i].item_no) {
            this.modifylist.push({
              item_no: this.list[i].item_no ? this.list[i].item_no : "",
              item_name: this.list[i].item_name ? this.list[i].item_name : "",
              barcode: this.list[i].barcode,
              sup_no: this.offlinesheet_info.sup_no,
              class_no: this.list[i].class_no,
              qty: this.list[i].qty,
              in_price: this.list[i].in_price,
              sale_price: this.list[i].buyer_sale_price,
              production_date: this.list[i].production_date
            });
          }
          this.offlinesheet_info.detail.push({
            item_no: this.list[i].item_no ? this.list[i].item_no : "",
            item_name: this.list[i].item_name ? this.list[i].item_name : "",
            class_no: this.list[i].class_no,
            barcode: this.list[i].barcode.trim(),
            qty: this.list[i].qty,
            in_price: this.list[i].in_price,
            sale_price: this.list[i].buyer_sale_price,
            production_date: this.list[i].production_date
          });
        }
      }
    },
    /**
     * radio1-2将商品基本信息导入后台
     * radio2-2将进价覆盖后台售价
     * radio2-2将售价覆盖后台售价
     * radio4-2将入库单导入后台
     */
    async approve() {
      this.$refs.supNoRef.validate(async v => {
        if (v) {
          this.getGoodsList();
          if (this.radio1 == "2" && this.radio4 != "2") {
            await this.insertoffline();
          }
          
          
          
          if (this.radio5 == "2") {
            this.Modifyoffline();
          }
          //生成入库单
          if (this.radio4 == "2") {
            await this.insertoffline();
            this.createSheet();
          }

          //单据审核
          const sheetappres = await sheetApprove(
            this.offlinesheet_info.sheet_no
          );
          if (
            this.testR(sheetappres) &&
            sheetappres.data.resp_data.state == "SUCCESS"
          ) {
            this.successMessage(sheetappres.data.resp_data.message);
            const list = [
              this.radio1 == "2" ? "2" : "1",
              this.radio2 == "2" ? "2" : "1",
              this.radio3 == "2" ? "2" : "1",
              this.radio4 == "2" ? "2" : "1",
              this.radio5 == "2" ? "2" : "1"
            ];
            localStorage.setItem("radiochecked", JSON.stringify(list));
            this.$emit("dyhauditsheetReturn", "1");
          }
          this.colseDialog();
        } else {
          this.warnMessage("请选择线下供应商。");
          return false;
        }
      });
      /* return;
      if(this.offlinesheet_info.sup_no==""||this.offlinesheet_info.sup_no.length==0){
        this.warnMessage("请选中线下供应商。");
        return;
      }
 */

      // console.log("审核单据",sheetappres);
      // loading.close();
    },
    colseDialog() {
      this.dialogFormVisible = false;
    },
    //插入新品
    async insertoffline() {
      const loading = this.$loading({
        lock: true,
        text: "正在导入新品",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        return new Promise(async (resolve, reject) => {
          //搜索商品库
          const res = await basegoodsBatchquery(this.goodslist);
          console.log("商品库返回",res);
          if (this.testR(res)) {
            const goodslist = res.data.resp_data;

            var offllineGenerate = [];
            for (let i = 0; i < goodslist.length; i++) {
              goodslist[i].sup_no = this.offlinesheet_info.sup_no;
              goodslist[i].sup_no = this.offlinesheet_info.sup_no;
              goodslist[i].barcode = goodslist[i].barcode
                ? goodslist[i].barcode.trim()
                : goodslist[i].barcode;
              for (let j = 0; j < this.offlinesheet_info.detail.length; j++) {

                /* console.log("goodslist---------", goodslist);
                 */
                if (
                  goodslist[i].barcode.trim() ==
                  this.offlinesheet_info.detail[j].barcode.trim()
                ) {
                  goodslist[i].class_no = this.offlinesheet_info.detail[
                    j
                  ].class_no;
                  goodslist[i].item_name = goodslist[i].item_name
                    ? goodslist[i].item_name
                    : this.offlinesheet_info.detail[j].item_name;
                }
              }
              console.log("商品库 goodslist",goodslist);
              //进价导入
              if (this.radio2 == "2") {
                for (let z = 0; z < this.offlinesheet_info.detail.length; z++) {
                  if (
                    goodslist[i].barcode.trim() ==
                    this.offlinesheet_info.detail[z].barcode.trim()
                  ) {
                    goodslist[i].in_price = this.offlinesheet_info.detail[
                      z
                    ].in_price;
                  }
                }
              }

              //售价导入
              if (this.radio3 == "2") {
                for (let z = 0; z < this.offlinesheet_info.detail.length; z++) {
                  if (
                    goodslist[i].barcode.trim() ==
                    this.offlinesheet_info.detail[z].barcode.trim()
                  ) {
                    goodslist[i].sale_price = this.offlinesheet_info.detail[
                      z
                    ].sale_price;
                  }
                }
              }
              goodslist[i].oper_no = localStorage.getItem("merchant_id");
              offllineGenerate.push(goodslist[i]);
            }

            const result = await offlineInsertGoods(
              offllineGenerate,
              this.branch_no
            );
            loading.close();
            if (this.testR(result)) {
              this.successMessage("商品信息导入成功！");
            }
            console.log("this.goodslist",this.goodslist);
            const offlinebquery = await offlineGoodsBatchQuery(this.goodslist);
            console.log("offlinebquery",offlinebquery);
            if (
              this.testR(offlinebquery) &&
              offlinebquery.data.return_code == "SUCCESS" &&
              offlinebquery.data.result_code == "SUCCESS" &&
              offlinebquery.data.resp_data
            ) {
              const tgoodslist = offlinebquery.data.resp_data;
              console.log("tggoodslist",tgoodslist);
              for (let i = 0; i < tgoodslist.length; i++) {
                //只有一个条码的时候
                if (tgoodslist[i][Object.keys(tgoodslist[i])[0]].length == 1) {
                  for (
                    let j = 0;
                    j < this.offlinesheet_info.detail.length;
                    j++
                  ) {
                    if (
                      this.offlinesheet_info.detail[j].barcode ==
                      Object.keys(tgoodslist[i])[0]
                    ) {
                      this.offlinesheet_info.detail[j].item_no =
                        tgoodslist[i][Object.keys(tgoodslist[i])[0]][0].item_no;
                    }
                  }
                }
              }
            }
          }
          resolve(true);
        });
      } catch (e) {
        reject(false);
        this.warnMessage(e);
        loading.close();
      }
    },
    async Modifyoffline() {
      const res = await modifyGoods(
        this.modifylist,
        this.offlinesheet_info.branch_no
      );
      if (this.testR(res)) {
        this.successMessage("商品信息修改成功！");
      }
    },
    //创建入库单
    async createSheet() {
      const res = await offlinecreateSheet(
        this.sheetwho,
        this.offlinesheet_info.sup_no,
        this.offlinesheet_info.sheet_no,
        this.offlinesheet_info.detail,
        this.offlinesheet_info.branch_no
      );
      this.testR(res);
      if (res.data.resp_data.isSuccess) {
        this.successMessage(res.data.resp_data.msg);
      }
    }
  }

  /**
   * 智能识别类别
   */
  /* goodslist[i].inline_class_no = goodslist[i].class_no
                ? goodslist[i].class_no
                : "";
               for (let j = 0; j < this.classlist.length; j++) {
                if (
                  goodslist[i].inline_class_no &&
                  goodslist[i].inline_class_no.trim() != "" &&
                  this.classlist[j].class_no.trim() != "" &&
                  goodslist[i].inline_class_no.trim() ==
                    this.classlist[j].class_no.trim()
                ) {
                  const offlineClass = await classifySmartDiscern(
                    this.classlist[j].class_name
                  );
                  if (testR(offlineClass)) {
                    goodslist[i].class_no = JSON.parse(
                      offlineClass.data.resp_data
                    ).class_no;
                  } else {
                    goodslist[i].class_no = this.class_no ? this.class_no : "";
                  }
                  //TODO: 预设
                } else {
                  goodslist[i].class_no = this.class_no ? this.class_no : "";
                }
              } */
};
</script>
<style lang="less" scoped>
.el-form-item {
  margin-bottom: 0;
}
.mch-name {
  font-size: 20px;
  margin: 10px 0;
}
</style>
